import React from 'react'
import Footer from '../../components/Footer/Footer'
import Navbar from '../../components/Header/Navbar'
import Table from '../../components/HostComponents/Table/Table'

const HostReservation = () => {
  return (
    <div>
      <Navbar/>
      <Table/>
      <Footer/>
    </div>
  )
}

export default HostReservation
